import React from 'react';
import ReactLightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';

import PhotoLabel from '@components/common/PhotoLabel/PhotoLabel';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const LightboxModal = ({ images, index }) => {
  const { setModalClose } = useModalActions();

  return (
    <ReactLightbox
      open
      className={style.lightboxImage}
      slides={images}
      index={index || 0}
      close={setModalClose}
      plugins={[Zoom]}
      render={{
        slideFooter: ({slide}) => (
          <div className={style.label}>
            <PhotoLabel sourceFrom={slide.sourceFrom} />
          </div>
        ),
        buttonPrev: images.length <= 1 ? () => null : undefined,
        buttonNext: images.length <= 1 ? () => null : undefined,
      }}
    />
  );
};

export default LightboxModal;
